import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManagePracticeRoutingModule } from './manage-practice-routing.module';
import { LandingComponent } from './landing/landing.component';
import { SharedTranslateLazyModule } from '../shared/shared-translate-lazy.module';
import { CommonUtilityModule } from '../shared/common-utility.module';
import { LeftMenuModule } from '../shared/left-menu.module';
import { LocationsComponent } from './locations/locations.component';
import { PracticeInformationComponent } from './practice-information/practice-information.component';

import { CounselorsComponent } from './practice-counselor/counselors/counselors.component';
import { AddCounselorsComponent } from './practice-counselor/add-counselors/add-counselors.component';
import { HomeComponent } from './locations/home/home.component';
import { MailingAddressComponent } from './locations/mailing-address/mailing-address.component';
import { BillingAddressComponent } from './locations/billing-address/billing-address.component';
import { ProviderSitesComponent } from './locations/provider-sites/provider-sites.component';
import { AddComponent } from './locations/provider-sites/add/add.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { AddressSharedModule } from '../shared/address-shared.module';
import { LicenseLiabilityModule } from './license-liability/license-liability.module';
import {MatSelectModule} from '@angular/material/select';
const maskConfigFunction: () => Partial<IConfig> = () => {
  return {
    validation: false,
  };
};
@NgModule({
  declarations: [
    LandingComponent
    , LocationsComponent
    , PracticeInformationComponent
    , CounselorsComponent
    , AddCounselorsComponent
    , HomeComponent, MailingAddressComponent, BillingAddressComponent, ProviderSitesComponent, AddComponent],
  imports: [
    CommonModule,
    ManagePracticeRoutingModule,
    LicenseLiabilityModule,
    FormsModule,
    ReactiveFormsModule,
    SharedTranslateLazyModule,
    CommonUtilityModule,
    LeftMenuModule,
    AddressSharedModule,
    NgxMaskModule.forRoot(maskConfigFunction),
    MatSelectModule
  
  ]
  
})
export class ManagePracticeModule { }
